import React from 'react';

const cn = (...classes: Array<string | false | null | undefined>) =>
  classes.filter(Boolean).join(' ');

interface DataCardLayoutProps {
  topRowSection?: React.ReactNode;
  mainInfoSection?: React.ReactNode;
  actionSection?: React.ReactNode;
}

export const DataCardLayout = ({
  topRowSection,
  mainInfoSection,
  actionSection,
}: DataCardLayoutProps) => (
  <div
    className={cn(
      'group rounded-2xl border border-gray-100 bg-white shadow-lg',
      'focus-within:ring-2 focus-within:ring-ptTeal/30'
    )}
  >
    <div className="p-5">
      {/* Top row: Category + Status */}
      {topRowSection && (
        <div className="flex items-start justify-between gap-3">
          {topRowSection}
        </div>
      )}

      {/* Main info */}
      <div className="pt-3 flex flex-col gap-2">
        {mainInfoSection}
      </div>
    </div>

    <hr/>

    {/* Actions */}
    <div className="p-5 flex items-center justify-end gap-2">
      {actionSection}
    </div>
  </div>
);